import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/client/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "ethereum"
    }}>{`Ethereum`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Ethereum is a decentralized, open-source blockchain with smart contract functionality. Ether (ETH) is the native cryptocurrency of the platform.`}</p>
    </blockquote>
    <p><img alt="Resouces to learn Ethereum" src="https://img.freepik.com/free-vector/shiny-silver-ethereum-coin_1302-10234.jpg?w=740" /></p>
    <h1 {...{
      "id": "resouces-to-learn-ethereum"
    }}>{`Resouces to learn Ethereum`}</h1>
    <ul>
      <li parentName="ul">{`📄`}<a parentName="li" {...{
          "href": "https://ethereum.org/en/"
        }}>{`Official Website`}</a></li>
      <li parentName="ul">{`▶️`}<a parentName="li" {...{
          "href": "https://www.forbes.com/advisor/investing/what-is-ethereum-ether/"
        }}>{`What Is Ethereum And How Does It Work?`}</a></li>
      <li parentName="ul">{`▶️`}<a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=uneCaqD6Etk"
        }}>{`Ethereum Tutorial For Beginners | What Is Ethereum? | Ethereum 2020 Explained | Simplilearn`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      